import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import APIs
import AllApi from "../../api/customer/address/All";

//import UIs
import AddressCard from "../../ui/cards/AddressCard";
import { ErrorNotify } from "../../ui/Toast";

//import skeletons
import AddressCardSkeleton from "../../ui/skeletons/AddressCard";

//import modal
import AddAddressModal from "../../ui/modals/AddAddress";

//icon
import AddIcon from "@mui/icons-material/Add";

// material Ui
import Button from "@mui/material/Button";

import { setIsLoading, setMetaData } from "../../redux/reducers/page";
const Address = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [addresses, setAddresses] = React.useState([]);

  const [addModalOpen, setAddModalOpen] = React.useState(false);

  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);

  // find Address addresses
  const findaddresses = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    const result = await AllApi(auth.token);

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      return;
    }
    setAddresses(result.data);

    setIsLoaded(true);
  };

  React.useEffect(() => {
    dispatch(
      setMetaData({
        title: "میشرت :   نشانی ها",
        description: "میشرت:  نشانی ها",
      })
    );
    dispatch(setIsLoading(false));
    findaddresses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="col-12 col-md-7  col-lg-6 col-xl-5  justify-content-center">
      <div className="row justify-content-center">
        <div className="col-12 m-2  text-left">
          <Button
            variant="contained"
            onClick={() => setAddModalOpen(true)}
            color="success"
            endIcon={<AddIcon />}
          >
            ثبت نشانی جدید
          </Button>
        </div>
      </div>
      <div className="row justify-content-center p-3 p-md-1">
        {" "}
        {isLoaded ? (
          addresses.map((address, index) => {
            return <AddressCard key={index} address={address} />;
          })
        ) : (
          <AddressCardSkeleton />
        )}
        <AddAddressModal
          openModal={addModalOpen}
          setOpenModal={setAddModalOpen}
          auth={auth}
          setAddresses={setAddresses}
        />
      </div>
    </div>
  );
};

export default Address;
